import i18n from '../locales';

export const ANNOUNCEMENT_TYPE_COLORS: Record<string, string> = {
  feature: 'var(--primary)',
  maintenance: 'var(--warning, #f59e0b)',
  update: 'var(--success)',
  alert: 'var(--danger)',
};

export const NOTIFICATION_TYPE_COLORS: Record<string, string> = {
  'video:completed': 'var(--success)',
  'video:failed': 'var(--danger)',
  'credits:recharged': 'var(--primary)',
  'script:completed': 'var(--success)',
  'script:failed': 'var(--danger)',
  'svclog:alert': 'var(--danger)',
  'ticket:new': 'var(--primary)',
  'ticket:reply': 'var(--primary)',
  'ticket:resolved': 'var(--success)',
  'ticket:reopened': 'var(--warning, #f59e0b)',
  'recharge_request:created': 'var(--primary)',
  'recharge_request:approved': 'var(--success)',
  'recharge_request:rejected': 'var(--danger)',
};

export function getAnnouncementTypeLabel(type: string): string {
  return i18n.t(`announcementTypes.${type}`, { ns: 'notifications', defaultValue: type });
}

export function getNotificationTypeLabel(type: string): string {
  return i18n.t(`notificationTypes.${type}`, { ns: 'notifications', defaultValue: type });
}
